import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Certifique-se de que esta variável está configurada no .env
});

// Injeta o token armazenado no localStorage (se houver) ao criar a instância
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Função para atualizar o token dinamicamente
export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
}

// Função para renovar o token usando o Refresh Token
export async function refreshAuthToken() {
  try {
    const refreshToken = localStorage.getItem('refreshToken'); // Certifique-se de salvar o Refresh Token no login
    if (!refreshToken) {
      throw new Error('Refresh Token não encontrado.');
    }

    const response = await api.post('/auth/refresh', { refreshToken });
    const { accessToken, refreshToken: newRefreshToken } = response.data;

    // Atualiza os tokens no localStorage e no cabeçalho Authorization
    localStorage.setItem('token', accessToken);
    localStorage.setItem('refreshToken', newRefreshToken);
    setAuthToken(accessToken);

    console.log('Token renovado com sucesso');
    return accessToken;
  } catch (error) {
    console.error('Erro ao renovar o token:', error);
    throw error;
  }
}

// Interceptor para lidar com erros de autenticação
api.interceptors.response.use(
  (response) => response, // Retorna a resposta se estiver tudo certo
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Token expirado. Tentando renovar...');
      try {
        await refreshAuthToken(); // Tenta renovar o token
        return api.request(error.config); // Reenvia a requisição original
      } catch (refreshError) {
        console.error('Falha ao renovar o token. Redirecionando para login.');
        // Redireciona para a página de login ou realiza logout
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error); // Propaga o erro
  }
);

export default api;